<ui-dialog
    (primaryButtonPressed)="mode === 'add' ? onAdd(form) : onEdit(form)"
    [primaryButtonLabel]="(mode === 'add' ? 'add' : 'save') | appTranslate"
    (closing)="closeDialog()"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    secondaryButtonType="ghost"
    [form]="form"
    size="small"
    [isCloseable]="true"
    [open]="openDialog"
    [header]="header"
>
    <form class="app-grid" #form="ngForm">
        <!-- Question Type-->
        <mat-form-field class="columns-6">
            <mat-label appRemoveAriaOwns>{{
                'applicant-tracker.components.additional-questions-dialog.questionType' | appTranslate
            }}</mat-label>
            <mat-select
                placeholder="{{ 'applicant-tracker.components.additional-questions-dialog.selectType' | appTranslate }}"
                [ngModel]="question.atsJobPostingQuestionTypeId"
                (ngModelChange)="onJobQuestionType($event)"
                name="selectedType"
                #selectedType="ngModel"
                [compareWith]="compareWith"
                required
            >
                <mat-select-trigger>
                    {{ jobPostingType[question.atsJobPostingQuestionTypeId] | appTranslate }}
                </mat-select-trigger>

                <mat-option
                    *ngFor="let jobQuestionType of jobQuestionTypes"
                    [value]="jobQuestionType"
                    class="margin-bottom-1"
                    ><div class="question-type-title">
                        {{ jobQuestionType.typeName | appTranslateOptions: questionTypeDisplay }}
                    </div>
                    <div class="question-type-info">
                        {{
                            jobQuestionType.description
                                | appTranslateOptions: questionTypeDescriptionDisplay
                                | lowercase
                        }}
                    </div></mat-option
                >
            </mat-select>
            <mat-error *ngIf="selectedType.invalid">{{ selectedType.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- Additional Question -->
        <mat-form-field class="columns-12">
            <mat-label>{{
                'applicant-tracker.components.additional-questions-dialog.additionalQuestions' | appTranslate
            }}</mat-label>
            <input
                [(ngModel)]="question.question"
                name="additionalQuestion"
                type="text"
                required
                matInput
                #additionalQuestion="ngModel"
            />
            <mat-error *ngIf="additionalQuestion.invalid">{{ additionalQuestion.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-checkbox
            [(ngModel)]="question.isRequired"
            class="columns-12 margin-bottom-2"
            name="additionalQuestionRequired"
            type="checkbox"
        >
            {{ 'applicant-tracker.components.additional-questions-dialog.thisIsARequiredQuestion' | appTranslate }}
        </mat-checkbox>

        <!-- Visibility -->
        <mat-form-field class="columns-6">
            <mat-label appRemoveAriaOwns>{{
                'applicant-tracker.components.additional-questions-dialog.visibility' | appTranslate
            }}</mat-label>
            <mat-select
                [(ngModel)]="question.accessLevelLabel"
                name="selectedVisibilityType"
                required
                #selectedVisibilityType="ngModel"
            >
                <mat-option *ngFor="let accessLevel of accessLevels" [value]="accessLevel" class="margin-bottom-1"
                    ><div class="question-type-title">{{ accessLevel | appTranslateOptions: accessLevelDisplay }}</div>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="selectedVisibilityType.invalid">{{
                selectedVisibilityType.errors | formErrors
            }}</mat-error>
        </mat-form-field>
    </form>
</ui-dialog>
